import React from 'react';
import {
  ResultCancelSubscriptionRow,
  ResultsCancelSubscriptionNameColumn,
  ResultsCancelSubscriptionStatusColumn,
  ResultsOrderNumber,
} from '../../../../../../tools/SearchPage/SearchResult.styles';
import {
  Checkbox,
  CheckBoxContainer,
} from '../../../../../../tools/SearchPage/CancelSubscriptionResult/CancelSubscriptionResult.styles';
import { formatOrderDateToLocalTime } from '../../../../../../../util';

const ResultList = ({ resultList, selectedSubscriptionsIds, resultClickAction }) => {
  return (
    <>
      {resultList.map((result) => {
        const checked = selectedSubscriptionsIds.includes(result.id);

        return (
          <ResultCancelSubscriptionRow key={result.id}>
            <CheckBoxContainer>
              <Checkbox type="checkbox" checked={checked} onChange={() => resultClickAction(result)} />
            </CheckBoxContainer>
            <ResultsCancelSubscriptionNameColumn>
              <ResultsOrderNumber>
                {result.lineItem.quantity} x {result.lineItem.title}
              </ResultsOrderNumber>
              <span> - </span>
              <span>{result.lineItem.price}</span>
            </ResultsCancelSubscriptionNameColumn>
            <ResultsCancelSubscriptionStatusColumn>
              {formatOrderDateToLocalTime(result.createdAt, 'common')}
            </ResultsCancelSubscriptionStatusColumn>
            <ResultsCancelSubscriptionStatusColumn active={result.status === 'ACTIVE'}>
              {result.status}
            </ResultsCancelSubscriptionStatusColumn>
          </ResultCancelSubscriptionRow>
        );
      })}
    </>
  );
};

export default ResultList;
